import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FilterService } from './filter.service';
import { VersioneDTO } from '../models/versione.model';

@Injectable({
  providedIn: 'root'
})

export class VersioneService {

  constructor(private http: HttpClient, private filterService: FilterService) {
  }

  getAllVersions(): Promise<Array<VersioneDTO>> {
    return this.http.get<Array<VersioneDTO>>(environment.apiFullUrl + '/Versione/GetAll').toPromise();
  }

  getVersioneByID(id: number): Promise<VersioneDTO> {
    return this.http.get<VersioneDTO>(environment.apiFullUrl + '/Versione/' + id).toPromise();
  }

  saveVersione(versione: VersioneDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Versione', versione).toPromise()
  }

  deleteVersione(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/Versione/' + id).toPromise();
  }
}